


































import {Component, Vue} from 'vue-property-decorator';
import AppFooter from '@/components/AppFooter.vue';
import AppDrawer from '@/components/AppDrawer.vue';
import AppHeader from '@/components/AppHeader.vue';
import Confirm from '@/components/Confirm.vue';
import { Getter } from 'vuex-class';
import { ISnackBar } from '@/models/Common';
import { triggerAsyncId } from 'async_hooks';
const namespace: string = 'AppStore';

@Component({
  components: {
    AppHeader,
    AppFooter,
    AppDrawer,
    Confirm,
  },
})
export default class App extends Vue {
  @Getter('snackBar', {namespace}) public snackBar!: ISnackBar;
  public confirmDialog: boolean = false;
  get bar() {
    return this.snackBar;
  }

  public created() {
    window.eventBus = this;
  }

  public mounted() {
    window.dialog = this.$refs.confirm;
  }
}
